var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { KeychainKeyTypesLC } from '@interfaces/keychain.interface';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, setWarningMessage, } from '@popup/multichain/actions/message.actions';
import { goBackToThenNavigate, navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { loadTokensMarket } from '@popup/steem/actions/token.actions';
import { BaseCurrencies } from '@popup/steem/utils/currency.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import TokensUtils from '@popup/steem/utils/tokens.utils';
import { Screen } from '@reference-data/screen.enum';
import { KeychainKeyTypes } from '@steempro/steem-keychain-commons';
import { throttle } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { ComplexeCustomSelect, } from 'src/common-ui/custom-select/custom-select.component';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
import { FormContainer } from 'src/common-ui/form-container/form-container.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import RotatingLogoComponent from 'src/common-ui/rotating-logo/rotating-logo.component';
import ServiceUnavailablePage from 'src/common-ui/service-unavailable-page/service-unavailable-page.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import Config from 'src/config';
import FormatUtils from 'src/utils/format.utils';
import Logger from 'src/utils/logger.utils';
import { SwapTokenUtils } from 'src/utils/swap-token.utils';
const TokenSwaps = ({ activeAccount, setErrorMessage, setSuccessMessage, navigateToWithParams, navigateTo, goBackToThenNavigate, addToLoadingList, removeFromLoadingList, setTitleContainerProperties, setWarningMessage, price, formParams, }) => {
    const [underMaintenance, setUnderMaintenance] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingEstimate, setLoadingEstimate] = useState(false);
    const [slippage, setSlippage] = useState(5);
    const [amount, setAmount] = useState('');
    const [startToken, setStartToken] = useState();
    const [endToken, setEndToken] = useState();
    const [startTokenListOptions, setStartTokenListOptions] = useState([]);
    const [endTokenListOptions, setEndTokenListOptions] = useState([]);
    const [estimate, setEstimate] = useState();
    const [estimateValue, setEstimateValue] = useState();
    const [autoRefreshCountdown, setAutoRefreshCountdown] = useState(null);
    const [isAdvancedParametersOpen, setIsAdvancedParametersOpen] = useState(false);
    const [serviceUnavailable, setServiceUnavailable] = useState(false);
    const throttledRefresh = useMemo(() => {
        return throttle((newAmount, newEndToken, newStartToken) => {
            if (parseFloat(newAmount) > 0 && newEndToken && newStartToken) {
                calculateEstimate(newAmount, newStartToken, newEndToken);
                setAutoRefreshCountdown(Config.swaps.autoRefreshPeriodSec);
            }
        }, 1000, { leading: false });
    }, []);
    useEffect(() => {
        throttledRefresh(amount, endToken, startToken);
    }, [amount, endToken, startToken]);
    useEffect(() => {
        init();
        setTitleContainerProperties({
            title: 'popup_html_token_swaps',
            isBackButtonEnabled: true,
        });
        return () => {
            throttledRefresh.cancel();
        };
    }, []);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        let tokenInitialization;
        try {
            setLoading(true);
            tokenInitialization = initTokenSelectOptions();
            const [serverStatus] = yield Promise.all([
                SwapTokenUtils.getServerStatus(),
            ]);
            setUnderMaintenance(serverStatus.isMaintenanceOn);
            if (serverStatus.layerTwoDelayed &&
                (!['STEEM', 'SBD'].includes(endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol) ||
                    !['STEEM', 'SBD'].includes(startToken === null || startToken === void 0 ? void 0 : startToken.value.symbol))) {
                setWarningMessage('swap_layer_two_delayed');
            }
        }
        catch (err) {
            Logger.error(err);
            setServiceUnavailable(true);
            // setErrorMessage(err.reason?.template, err.reason?.params);
        }
        finally {
            yield tokenInitialization;
            if (formParams.startToken) {
                setStartToken(formParams.startToken);
            }
            if (formParams.endToken) {
                setEndToken(formParams.endToken);
            }
            if (formParams.amount) {
                setAmount(formParams.amount);
            }
            if (formParams.slipperage) {
                setSlippage(formParams.slipperage);
            }
            setLoading(false);
        }
    });
    useEffect(() => {
        if (autoRefreshCountdown === null) {
            return;
        }
        if (autoRefreshCountdown === 0 && startToken && endToken) {
            calculateEstimate(amount, startToken, endToken);
            setAutoRefreshCountdown(Config.swaps.autoRefreshPeriodSec);
            return;
        }
        const a = setTimeout(() => {
            setAutoRefreshCountdown(autoRefreshCountdown - 1);
        }, 1000);
        return () => {
            clearTimeout(a);
        };
    }, [autoRefreshCountdown]);
    const initTokenSelectOptions = () => __awaiter(void 0, void 0, void 0, function* () {
        const startList = yield SwapTokenUtils.getSwapTokenStartList(activeAccount.account);
        let list = startList.map((token) => {
            let img = '';
            let imgBackup = '';
            img =
                token.symbol === BaseCurrencies.STEEM.toUpperCase()
                    ? `/assets/images/wallet/steem-logo.svg`
                    : `/assets/images/wallet/sbd-logo.svg`;
            return {
                value: token,
                label: token.symbol,
                img: img,
                imgBackup,
            };
        });
        let endList = [
            {
                value: { symbol: BaseCurrencies.STEEM.toUpperCase(), precision: 3 },
                label: BaseCurrencies.STEEM.toUpperCase(),
                img: `/assets/images/wallet/steem-logo.svg`,
            },
            {
                value: { symbol: BaseCurrencies.SBD.toUpperCase(), precision: 3 },
                label: BaseCurrencies.SBD.toUpperCase(),
                img: `/assets/images/wallet/sbd-logo.svg`,
            },
        ];
        const lastUsed = yield SwapTokenUtils.getLastUsed();
        setStartToken(lastUsed.from
            ? list.find((t) => t.value.symbol === lastUsed.from.symbol) || list[0]
            : list[0]);
        setStartTokenListOptions(list);
        const endTokenToSet = lastUsed.to
            ? endList.find((t) => t.value.symbol === lastUsed.to.symbol)
            : endList[1];
        setEndToken(endTokenToSet);
        setEndTokenListOptions(endList);
    });
    const calculateEstimate = (amount, startToken, endToken) => __awaiter(void 0, void 0, void 0, function* () {
        if (startToken === endToken) {
            setErrorMessage('swap_start_end_token_should_be_different');
            return;
        }
        try {
            setLoadingEstimate(true);
            setEstimate(undefined);
            setEstimateValue(undefined);
            const result = yield SwapTokenUtils.getEstimate(startToken === null || startToken === void 0 ? void 0 : startToken.value.symbol, endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol, amount, () => {
                setAutoRefreshCountdown(null);
            });
            if ((result === null || result === void 0 ? void 0 : result.steem_volume) && (result === null || result === void 0 ? void 0 : result.sbd_volume)) {
                const value = Number(startToken.label === 'STEEM' ? result.highest_bid : result.lowest_ask);
                const fee = 0;
                const finalValue = Number(Number(amount) * value - fee).toFixed(3);
                setEstimate([
                    {
                        provider: 'STEEM_INTERNAL_MARKET',
                        startToken: startToken.label,
                        endToken: endToken.label,
                        id: 0,
                        amountStartToken: Number(amount),
                        type: 'SELL_ON_MARKET',
                        estimate: Number(finalValue),
                        stepNumber: 0,
                    },
                ]);
                setEstimateValue(finalValue);
            }
            else {
                setEstimateValue(undefined);
            }
        }
        catch (err) {
            setEstimate(undefined);
            setErrorMessage(err.reason.template, err.reason.params);
        }
        finally {
            setLoadingEstimate(false);
        }
    });
    const processSwap = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!estimate) {
            setErrorMessage('swap_no_estimate_error');
            return;
        }
        // if (slippage < swapConfig.slippage.min) {
        //   setErrorMessage('swap_min_slippage_error', [
        //     swapConfig.slippage.min.toString(),
        //   ]);
        //   return;
        // }
        if ((startToken === null || startToken === void 0 ? void 0 : startToken.value.symbol) === (endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol)) {
            setErrorMessage('swap_start_end_token_should_be_different');
            return;
        }
        if (!amount || amount.length === 0) {
            setErrorMessage('popup_html_need_positive_amount');
            return;
        }
        if (parseFloat(amount) > parseFloat(startToken === null || startToken === void 0 ? void 0 : startToken.value.balance)) {
            setErrorMessage('hive_engine_overdraw_balance_error', [
                startToken === null || startToken === void 0 ? void 0 : startToken.label,
            ]);
            return;
        }
        let estimateId;
        try {
            estimateId = yield SwapTokenUtils.saveEstimate(estimate, slippage, startToken === null || startToken === void 0 ? void 0 : startToken.value.symbol, endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol, parseFloat(amount), activeAccount.name);
        }
        catch (err) {
            setErrorMessage(err.reason.template, err.reason.params);
            return;
        }
        const startTokenPrecision = yield TokensUtils.getTokenPrecision(startToken === null || startToken === void 0 ? void 0 : startToken.value.symbol);
        const endTokenPrecision = yield TokensUtils.getTokenPrecision(endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol);
        const fields = [
            { label: 'html_popup_swap_swap_id', value: estimateId },
            {
                label: 'html_popup_swap_swap_amount',
                value: `${FormatUtils.withCommas(Number(amount).toFixed(startTokenPrecision))} ${startToken === null || startToken === void 0 ? void 0 : startToken.value.symbol} => ${FormatUtils.withCommas(estimateValue.toString())} ${endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol}`,
            },
            {
                label: 'html_popup_swap_swap_slipperage',
                value: `${slippage}% (for each step)`,
            },
        ];
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('html_popup_swap_token_confirm_message'),
            fields: fields,
            title: 'html_popup_swap_token_confirm_title',
            formParams: getFormParams(),
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_swap_sending_token_to_swap_account', KeysUtils.getKeyType(activeAccount.keys.active, activeAccount.keys.activePubkey, activeAccount.account, activeAccount.account), [startToken === null || startToken === void 0 ? void 0 : startToken.value.symbol]);
                try {
                    let success;
                    // success = await SwapTokenUtils.processSwap(
                    //   estimateId,
                    //   startToken?.value.symbol,
                    //   parseFloat(amount),
                    //   activeAccount,
                    //   options,
                    // );
                    removeFromLoadingList('html_popup_swap_sending_token_to_swap_account');
                    if (success) {
                        yield SwapTokenUtils.saveLastUsed(startToken === null || startToken === void 0 ? void 0 : startToken.value, endToken === null || endToken === void 0 ? void 0 : endToken.value);
                        setSuccessMessage('swap_multisig_transaction_sent_to_signers');
                        goBackToThenNavigate(Screen.TOKENS_SWAP_HISTORY);
                    }
                    else if (success && (success === null || success === void 0 ? void 0 : success['tx_id'])) {
                        yield SwapTokenUtils.saveLastUsed(startToken === null || startToken === void 0 ? void 0 : startToken.value, endToken === null || endToken === void 0 ? void 0 : endToken.value);
                        yield SwapTokenUtils.setAsInitiated(estimateId);
                        setSuccessMessage('html_popup_swap_sending_token_successful');
                        goBackToThenNavigate(Screen.TOKENS_SWAP_HISTORY);
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_delegate_rc_operation');
                }
            }),
            afterCancelAction: () => __awaiter(void 0, void 0, void 0, function* () {
                yield SwapTokenUtils.cancelSwap(estimateId);
            }),
        });
    });
    const getFormParams = () => {
        return {
            startToken: startToken,
            endToken: endToken,
            amount: amount,
            slipperage: slippage,
        };
    };
    const swapStartAndEnd = () => {
        const option = startTokenListOptions.find((option) => option.value.symbol === (endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol));
        if (option) {
            const tmp = startToken;
            setStartToken(option);
            setEndToken(tmp);
        }
        else {
            setErrorMessage('swap_cannot_switch_tokens', endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol);
        }
    };
    const getTokenUSDPrice = (estimateValue, symbol) => {
        if (!estimateValue)
            return '';
        else {
            let tokenPrice;
            if (symbol === BaseCurrencies.STEEM.toUpperCase()) {
                tokenPrice = price.steem.usd;
            }
            else if (symbol === BaseCurrencies.SBD.toUpperCase()) {
                tokenPrice = price.steem_dollars.usd;
            }
            return `≈ $${FormatUtils.withCommas(Number.parseFloat(estimateValue) + '', 2)}`;
        }
    };
    if (loading)
        return (React.createElement("div", { className: "rotating-logo-wrapper" },
            React.createElement(RotatingLogoComponent, null)));
    else if (!startTokenListOptions.length) {
        return (React.createElement("div", { className: "token-swaps", "aria-label": "token-swaps" },
            React.createElement("div", null,
                React.createElement("div", { className: "caption" },
                    ' ',
                    getMessage('swap_no_token')))));
    }
    else
        return (React.createElement("div", { className: "token-swaps", "aria-label": "token-swaps" },
            !loading && !underMaintenance && !serviceUnavailable && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "caption" }, getMessage('swap_caption')),
                React.createElement("div", { className: "top-row" },
                    React.createElement("div", { className: "fee" },
                        getMessage('swap_fee'),
                        ": 0"),
                    React.createElement(SVGIcon, { className: "swap-history-button", icon: SVGIcons.SWAPS_HISTORY, onClick: () => navigateTo(Screen.TOKENS_SWAP_HISTORY) })),
                React.createElement(FormContainer, null,
                    React.createElement("div", { className: "form-fields" },
                        React.createElement("div", { className: "start-token" },
                            React.createElement("div", { className: "inputs" },
                                startTokenListOptions.length > 0 && startToken && (React.createElement(ComplexeCustomSelect, { selectedItem: startToken, options: startTokenListOptions, setSelectedItem: setStartToken, label: "token", filterable: true })),
                                React.createElement(InputComponent, { type: InputType.NUMBER, value: amount, onChange: setAmount, label: "popup_html_transfer_amount", placeholder: "popup_html_transfer_amount", min: 0, rightActionClicked: () => setAmount(startToken === null || startToken === void 0 ? void 0 : startToken.value.balance), rightActionIcon: SVGIcons.INPUT_MAX })),
                            React.createElement("span", { className: "available" },
                                getMessage('popup_html_available'),
                                " :",
                                ' ',
                                (startToken === null || startToken === void 0 ? void 0 : startToken.value.balance)
                                    ? FormatUtils.withCommas(startToken === null || startToken === void 0 ? void 0 : startToken.value.balance)
                                    : '')),
                        React.createElement(SVGIcon, { icon: SVGIcons.SWAPS_SWITCH, onClick: swapStartAndEnd, className: "swap-icon" }),
                        React.createElement("div", { className: "end-token" },
                            React.createElement("div", { className: "inputs" },
                                endTokenListOptions.length > 0 && endToken && (React.createElement(ComplexeCustomSelect, { selectedItem: endToken, options: endTokenListOptions, setSelectedItem: setEndToken, label: "token", filterable: true })),
                                React.createElement(CustomTooltip, { color: "grey", message: getTokenUSDPrice(estimateValue, endToken === null || endToken === void 0 ? void 0 : endToken.value.symbol), position: 'top', skipTranslation: true },
                                    React.createElement(InputComponent, { type: InputType.TEXT, value: estimateValue
                                            ? FormatUtils.withCommas(estimateValue)
                                            : '', disabled: true, onChange: () => { }, placeholder: "popup_html_transfer_amount", rightActionIconClassname: loadingEstimate ? 'rotate' : '', rightActionIcon: SVGIcons.SWAPS_ESTIMATE_REFRESH, rightActionClicked: () => {
                                            if (!estimate)
                                                return;
                                            calculateEstimate(amount, startToken, endToken);
                                            setAutoRefreshCountdown(Config.swaps.autoRefreshPeriodSec);
                                        } }))),
                            React.createElement("div", { className: "countdown" }, !!autoRefreshCountdown && (React.createElement(React.Fragment, null, React.createElement("span", null, getMessage('swap_autorefresh', [autoRefreshCountdown + ''])))))),
                        React.createElement("div", { className: "advanced-parameters" },
                            React.createElement("div", { className: "title-panel", onClick: () => setIsAdvancedParametersOpen(!isAdvancedParametersOpen) },
                                React.createElement("div", { className: "title" }, getMessage('swap_advanced_parameters')),
                                React.createElement(SVGIcon, { icon: SVGIcons.GLOBAL_ARROW, onClick: () => setIsAdvancedParametersOpen(!isAdvancedParametersOpen), className: `advanced-parameters-toggle ${isAdvancedParametersOpen ? 'open' : 'closed'}` })),
                            isAdvancedParametersOpen && (React.createElement("div", { className: "advanced-parameters-container" },
                                React.createElement(InputComponent, { type: InputType.NUMBER, min: 5, step: 1, value: slippage, onChange: setSlippage, label: "html_popup_swaps_slipperage", placeholder: "html_popup_swaps_slipperage" }))))),
                    React.createElement(OperationButtonComponent, { requiredKey: KeychainKeyTypesLC.active, onClick: processSwap, disabled: true, 
                        // label={'html_popup_swaps_process_swap'}
                        label: 'swap_under_maintenance' })))),
            underMaintenance && (React.createElement("div", { className: "maintenance-mode" },
                React.createElement(SVGIcon, { icon: SVGIcons.MESSAGE_ERROR }),
                React.createElement("div", { className: "text" }, getMessage('swap_under_maintenance')))),
            serviceUnavailable && React.createElement(ServiceUnavailablePage, null)));
};
const mapStateToProps = (state) => {
    var _a, _b;
    return {
        activeAccount: state.steem.activeAccount,
        price: state.steem.currencyPrices,
        tokenMarket: state.steem.tokenMarket,
        formParams: ((_a = state.navigation.stack[0].previousParams) === null || _a === void 0 ? void 0 : _a.formParams)
            ? (_b = state.navigation.stack[0].previousParams) === null || _b === void 0 ? void 0 : _b.formParams
            : {},
    };
};
const connector = connect(mapStateToProps, {
    setErrorMessage,
    setSuccessMessage,
    navigateToWithParams,
    navigateTo,
    addToLoadingList,
    removeFromLoadingList,
    goBackToThenNavigate,
    setTitleContainerProperties,
    loadTokensMarket,
    setWarningMessage,
});
export const TokenSwapsComponent = connector(TokenSwaps);
